import { gql } from '@apollo/client';

const getSupplierOrderStatuses = gql`query getSupplierOrderStatuses{
	incomingOrdersContext{
		listOrderStatuses
		{
			id
			name
			action
			productionStatus
			color
			actionTrigger
		}
	}
}`;

export default getSupplierOrderStatuses;